export const globalWindow = typeof window === 'undefined' ? undefined : window
